import { useState } from "react";
import { X } from "lucide-react";

const UserGuideModal = ({ isOpen, onClose, role }) => {
  const guides = {
    receptionist: [
      { title: "Dashboard", points: ["View appointments, waitlist, and check-ins", "Create new appointments", "Register urgent cases"] },
      { title: "Users Section", points: ["Create new users (receptionists and students)", "Edit user information"] },
      { title: "Appointments Section", points: ["View appointment details"] },
      { title: "Profile Section", points: ["View and edit personal profile"] },
    ],
    counselor: [
      { title: "Dashboard Section", points: ["View scheduled appointments", "View pending actions"] },
      { title: "Appointments Section", points: ["View appointment details"] },
      { title: "Sessions Section", points: ["View and manage counseling sessions"] },
      { title: "Profile Section", points: ["View and edit personal profile"] },
    ],
    hod: [
      { title: "Dashboard Section", points: ["Generate new reports"] },
      { title: "Appointments Section", points: ["View appointment details"] },
      { title: "Sessions Section", points: ["View and manage counseling sessions"] },
      { title: "Profile Section", points: ["View and edit personal profile"] },
    ],
    student: [
      { title: "Dashboard Section", points: ["View upcoming appointments, completed sessions, available counselors and goal progress", "Book a new appointment", "View recent sessions", "View session history"] },
      { title: "Appointments Section", points: ["View appointment details", "Book a new appointment"] },
      { title: "Sessions Section", points: ["View counseling sessions"] },
      { title: "Profile Section", points: ["View and edit personal profile"] },
    ],
    staff: [
      { title: "Dashboard Section", points: ["View upcoming appointments", "Book a new appointment"] },
      { title: "Appointments Section", points: ["View appointment details"] },
      { title: "Sessions Section", points: ["View counseling sessions"] },
      { title: "Profile Section", points: ["View and edit personal profile"] },
    ],
    administrator: [
      { title: "Dashboard Section", points: ["Filter analytics", "View system performance", "View user statistics", "View session trends", "View counsellor performance"] },
      { title: "Users Section", points: ["Create and edit user details"] },
      { title: "Appointments Section", points: ["View appointment details"] },
      { title: "Sessions Section", points: ["View session details"] },
      { title: "Profile Section", points: ["View and edit personal profile"] },
    ],
  };

  return (
    isOpen && (
      // <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      //     <div className="bg-white p-6 w-11/12 max-w-lg rounded-xl shadow-lg relative">
      //         <button onClick={onClose} className="absolute top-2 right-2 text-gray-600 hover:text-gray-900">
      //             <X size={20} />
      //         </button>
      //         <h2 className="text-xl font-bold mb-4">User Guide</h2>
      //         <div className="space-y-4">
      //             {guides[role]?.map((section) => (
      //                 <div key={section.title}>
      //                     <h3 className="text-lg font-semibold">{section.title}</h3>
      //                     <ul className="list-disc pl-5">
      //                         {section.points.map((point, index) => (
      //                             <li key={index} className="text-sm">{point}</li>
      //                         ))}
      //                     </ul>
      //                 </div>
      //             ))}
      //         </div>
      //     </div>
      // </div>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white p-12 w-11/12 max-w-4xl rounded-xl shadow-lg relative">
          <button onClick={onClose} className="absolute top-2 right-2 text-gray-600 hover:text-gray-900">
            <X size={20} />
          </button>
          <h2 className="text-2xl font-bold mb-6 text-center">User Guide</h2>
          <div className="grid gap-4 sm:grid-cols-1 lg:grid-cols-2 p-6">
            {guides[role]?.map((section) => (
              <div key={section.title} className="bg-gray-50 p-4 rounded-2xl shadow-md">
                <h3 className="text-lg font-semibold mb-2 text-gray-700">{section.title}</h3>
                <ul className="list-disc pl-5 space-y-1">
                  {section.points.map((point, index) => (
                    <li key={index} className="text-sm text-gray-600">{point}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  );
};

export default UserGuideModal;
